
//Definición de defaults

export const defaultTipoDomicilio: TipoDomicilioProps = {
    idTipoDomicilio:    0,
    descripcion:        '',  
    activo:             false,
}

// Creación de interfaces

export interface TipoDomicilioProps{
    idTipoDomicilio:  number;
    descripcion:    string;
    activo:         boolean;
}
